const professional = {
  root: "professional",
  root_plural: "professionals",
  website: "Website",
  details: "Details of the professional",
  no_hairdresser: "No hairdresser",
};
export default professional;
